import {Badge} from "@/components/ui/badge";
import {cn} from "@/lib/utils";

import {getSafelistingCoverageStatus} from "../lib/has-future-date";
import type {Safelisting} from "../types";
import {SafelistingCoverageStatusBadge} from "./safelisting-coverage-status-badge";

type SafelistingCoverageStatusClusterProps = {
  safelisting: Safelisting;
  timeZone: string;
  startHumanLabel?: string | null;
  className?: string;
  badgeClassName?: string;
  align?: "start" | "end";
  amenityRestricted?: boolean;
};

export function SafelistingCoverageStatusCluster({
  safelisting,
  timeZone,
  startHumanLabel,
  className,
  badgeClassName,
  align = "end",
  amenityRestricted,
}: SafelistingCoverageStatusClusterProps) {
  const anchorLabel = startHumanLabel?.trim() ?? null;
  const status = getSafelistingCoverageStatus(safelisting, timeZone);
  const showStartLabel = status === "scheduled" && anchorLabel != null;

  return (
    <div
      className={cn(
        "flex max-w-full shrink-0 flex-col gap-1",
        align === "end" ? "items-end" : "items-start",
        className,
      )}
    >
      <SafelistingCoverageStatusBadge
        safelisting={safelisting}
        timeZone={timeZone}
        className={badgeClassName}
        amenityRestricted={amenityRestricted}
      />
      {showStartLabel ? (
        <Badge variant="default" className="text-xs font-semibold whitespace-nowrap">
          {anchorLabel}
        </Badge>
      ) : null}
    </div>
  );
}
